export const empty = (x) => !x || !((typeof x === 'object' && Object.keys(x).length > 0) || (x || []).length > 0)

export const notEmpty = (x) => !empty(x)
